import styled from 'styled-components';

export const RoadTravelInsightsStyles = styled.section``;
